/**
 * Static Marathi/Hindi translations for common prescription terms.
 * Handles frequencies (OD, BD, TDS, HS, SOS, etc.), timings (Before food, At bedtime),
 * routes (Oral, SC, IV) and common patient-friendly phrases.
 */

const MR = {
  // Frequency
  "OD": "दिवसातून एकदा",
  "BD": "दिवसातून दोनदा",
  "TDS": "दिवसातून तीनदा",
  "QID": "दिवसातून चारदा",
  "HS": "झोपण्यापूर्वी",
  "SOS": "गरजेप्रमाणे",
  "Q4H": "दर ४ तासांनी",
  "Q6H": "दर ६ तासांनी",
  "Q8H": "दर ८ तासांनी",
  "Q12H": "दर १२ तासांनी",
  "Once weekly": "आठवड्यातून एकदा",
  "As per regimen": "डोसच्या वेळापत्रकानुसार",
  // Timing
  "Before food": "जेवणापूर्वी",
  "After food": "जेवणानंतर",
  "With food": "जेवणासोबत",
  "Empty stomach": "उपाशीपोटी",
  "At bedtime": "झोपण्यापूर्वी",
  "Morning": "सकाळी",
  "Evening": "संध्याकाळी",
  "Night": "रात्री",
  // Route
  "Oral": "तोंडावाटे",
  "SC": "त्वचेखाली इंजेक्शन",
  "IV": "शिरेतून",
  "IM": "स्नायूत",
  "Inhalation": "श्वासाद्वारे",
  "Topical": "बाह्य लेप",
  "Sublingual": "जिभेखाली",
  // Common instructions
  "Take with meals": "जेवणासोबत घ्या",
  "Rotate injection sites": "इंजेक्शनचे ठिकाण बदला",
  "For fever/pain": "ताप/वेदनेसाठी",
  "Complete full course": "पूर्ण कोर्स संपवा",
  "Stay hydrated": "पुरेसे पाणी प्या",
  "30 min before breakfast": "नाश्त्याच्या ३० मिनिटे आधी",
  "Wait 30 min before food": "जेवणाच्या ३० मिनिटे आधी",
  "For 3-5 days": "३-५ दिवसांसाठी",
  "For 8 weeks": "८ आठवड्यांसाठी",
  "Rinse mouth after use": "वापरानंतर तोंड धुवा",
  "Reconstitute with WFI": "इंजेक्शनसाठी WFI मध्ये मिसळा",
  "Max 4g/day": "दिवसाला जास्तीत जास्त ४ ग्रॅम",
  "Avoid in CKD": "किडनी रुग्णांनी टाळा",
  "Monitor potassium": "पोटॅशियम तपासा",
  // Card instructions (guidance one-tap cards)
  "Dissolve under tongue.": "जिभेखाली विरघळू द्या.",
  "Chew slowly till tingling, then park between cheek and gum. No food/drink 15 min before.": "झिणझिण्या येईपर्यंत हळू चावा, मग गाल व हिरडीमध्ये ठेवा. आधी १५ मिनिटे खाणे-पिणे टाळा.",
  "Increase weekly as advised. Report any skin rash immediately.": "सांगितल्याप्रमाणे दर आठवड्याला डोस वाढवा. त्वचेवर पुरळ आल्यास लगेच कळवा.",
  "First 3 doses 72 hrs apart, then weekly.": "पहिले ३ डोस ७२ तासांच्या अंतराने, नंतर आठवड्यातून एकदा.",
  "After fatty meal": "स्निग्ध जेवणानंतर",
  "After breakfast": "नाश्त्यानंतर",
  "After dinner": "रात्रीच्या जेवणानंतर",
  "After lunch": "दुपारच्या जेवणानंतर",
  "Bedtime": "झोपताना",
  "Before breakfast": "नाश्त्यापूर्वी",
  "Same time daily": "दररोज त्याच वेळी",
  "Any time, consistent": "कोणत्याही वेळी, दररोज त्याच वेळी",
  "Bedtime with warm water": "झोपताना कोमट पाण्यासोबत",
  "Heavy days only (max 5 days)": "फक्त जास्त रक्तस्रावाच्या दिवशी (जास्तीत जास्त ५ दिवस)",
};

const HI = {
  // Frequency
  "OD": "दिन में एक बार",
  "BD": "दिन में दो बार",
  "TDS": "दिन में तीन बार",
  "QID": "दिन में चार बार",
  "HS": "सोने से पहले",
  "SOS": "आवश्यकता होने पर",
  "Q4H": "हर ४ घंटे में",
  "Q6H": "हर ६ घंटे में",
  "Q8H": "हर ८ घंटे में",
  "Q12H": "हर १२ घंटे में",
  "Once weekly": "सप्ताह में एक बार",
  "As per regimen": "निर्धारित समय अनुसार",
  // Timing
  "Before food": "खाने से पहले",
  "After food": "खाने के बाद",
  "With food": "खाने के साथ",
  "Empty stomach": "खाली पेट",
  "At bedtime": "सोने से पहले",
  "Morning": "सुबह",
  "Evening": "शाम",
  "Night": "रात",
  // Route
  "Oral": "मुंह से",
  "SC": "त्वचा के नीचे इंजेक्शन",
  "IV": "नस में",
  "IM": "मांसपेशी में",
  "Inhalation": "सांस के द्वारा",
  "Topical": "बाहरी लेप",
  "Sublingual": "जीभ के नीचे",
  // Common instructions
  "Take with meals": "खाने के साथ लें",
  "Rotate injection sites": "इंजेक्शन की जगह बदलें",
  "For fever/pain": "बुखार/दर्द के लिए",
  "Complete full course": "पूरा कोर्स पूरा करें",
  "Stay hydrated": "पर्याप्त पानी पिएं",
  "30 min before breakfast": "नाश्ते से ३० मिनट पहले",
  "Wait 30 min before food": "खाने से ३० मिनट पहले",
  "For 3-5 days": "३-५ दिन के लिए",
  "For 8 weeks": "८ हफ्तों के लिए",
  "Rinse mouth after use": "उपयोग के बाद कुल्ला करें",
  "Reconstitute with WFI": "WFI में मिलाएं",
  "Max 4g/day": "अधिकतम ४ ग्राम प्रतिदिन",
  "Avoid in CKD": "किडनी रोगियों के लिए नहीं",
  "Monitor potassium": "पोटैशियम की जांच करें",
  // Card instructions (guidance one-tap cards)
  "Dissolve under tongue.": "जीभ के नीचे घुलने दें।",
  "Chew slowly till tingling, then park between cheek and gum. No food/drink 15 min before.": "झुनझुनी होने तक धीरे चबाएँ, फिर गाल और मसूड़े के बीच रखें। पहले १५ मिनट कुछ न खाएँ-पिएँ।",
  "Increase weekly as advised. Report any skin rash immediately.": "बताए अनुसार हर सप्ताह खुराक बढ़ाएँ। त्वचा पर चकत्ते होने पर तुरंत बताएँ।",
  "First 3 doses 72 hrs apart, then weekly.": "पहली ३ खुराक ७२ घंटे के अंतर पर, फिर साप्ताहिक।",
  "After fatty meal": "वसायुक्त भोजन के बाद",
  "After breakfast": "नाश्ते के बाद",
  "After dinner": "रात के खाने के बाद",
  "After lunch": "दोपहर के खाने के बाद",
  "Bedtime": "सोने से पहले",
  "Before breakfast": "नाश्ते से पहले",
  "Same time daily": "रोज़ एक ही समय पर",
  "Any time, consistent": "किसी भी समय, रोज़ एक ही समय पर",
  "Bedtime with warm water": "सोते समय गुनगुने पानी के साथ",
  "Heavy days only (max 5 days)": "केवल अधिक रक्तस्राव वाले दिनों में (अधिकतम ५ दिन)",
};

const DICT = { mr: MR, hi: HI };

/** Translate a single term. Custom overrides win over static dict.
 *  @param {string} text
 *  @param {"en"|"mr"|"hi"} lang
 *  @param {Record<string, {mr?:string, hi?:string}>} custom optional custom dictionary keyed by english
 */
export function tr(text, lang, custom) {
  if (!text || !lang || lang === "en") return "";
  const key = String(text).trim();
  if (custom && custom[key] && custom[key][lang]) return custom[key][lang];
  return DICT[lang]?.[key] || "";
}

/** Try to translate a compact multi-part instruction like "OD After food" or "BD (After food)". */
export function trPhrase(text, lang, custom) {
  if (!text || !lang || lang === "en") return "";
  const direct = tr(text, lang, custom);
  if (direct) return direct;
  const parts = String(text).split(/[·\-,;()]|\s{2,}/).map((p) => p.trim()).filter(Boolean);
  const out = parts.map((p) => tr(p, lang, custom) || p).filter((p, i, a) => a.indexOf(p) === i);
  return out.join(" · ");
}

export const LANGS = [
  { code: "en", label: "English", native: "English" },
  { code: "mr", label: "Marathi", native: "मराठी" },
  { code: "hi", label: "Hindi", native: "हिंदी" },
];
